import { createAsyncThunk } from '@reduxjs/toolkit';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../../firebaseConfig';
import { getErrorMessage } from '../utils.js';
import { isAdminUser } from '../../../../utils/adminUtils';

// Check if user is approved (for login flow)
export const checkUserApproval = createAsyncThunk(
  'waitlist/checkApproval',
  async (email, { rejectWithValue }) => {
    try {
      // Admins are always approved — bypass waitlist_entries check
      if (isAdminUser(email)) return true;

      const waitlistRef = collection(db, 'waitlist_entries');
      const q = query(
        waitlistRef,
        where('email', '==', email.toLowerCase()),
        where('status', '==', 'approved')
      );
      const querySnapshot = await getDocs(q);

      return !querySnapshot.empty;
    } catch (error) {
      console.error('Error checking user approval:', error);
      return rejectWithValue(getErrorMessage(error));
    }
  }
);
